<template>
  <div>
    <!-- Modal Wheel -->
    <div class="modal fade z-3" id="modalBannerWheel" tabindex="-1" aria-labelledby="modalBannerLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered z-3">
        <div class="modal-content backgr">
          <div class="text-end">
            <button type="button" class="btn-close m-2 position-absolute end-0" data-bs-dismiss="modal"
              aria-label="Close" id="closeModal"> <i class="bi bi-0-circle"></i></button>
          </div>
          <div class="modal-body p-0 text-center bg-pink-gradient" style="--bs-bg-opacity: .5;">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12 bg-title pt-4 pb-3 title-font">
                  <h3>DON'T MISS OUT ON THESE</h3>
                  <h3>LUCKY DEALS!</h3>
                </div>
                <div class="col text-center pt-4">
                  <div class="row text-center pb-0">
                    <h3 class="title-font pb-0 mb-0">CLICK THE GOLD POT TO</h3>
                    <span class="special-title-font">Reveal your Prize</span>
                    <!-- <div class="col pb-0 mb-0"><img src="../assets/images/winwheel/valentines/pointer.png" alt=""
                              class="w-25 position-absolute pointer"></div>
                        </div> -->
                    <div class="col bg-pot pb-5">
                      <img src="../assets/images/campaigns/st-patricks/pot.png" alt=""
                        class="w-75 tilt-n-move-shaking pot"
                        @click="showModal('closeModal', '#modalPrize', true)">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Prize -->
    <div class="modal fade " id="modalPrize" tabindex="-1" aria-labelledby="modalPrize" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content backgr">
          <div class="text-end">
            <button type="button" class="btn-close m-2 position-absolute end-0" data-bs-dismiss="modal"
              aria-label="Close" id="closePrizeModal"></button>
          </div>
          <div class="modal-body p-0 text-center bg-pink-gradient" style="--bs-bg-opacity: .5;">
            <div class="container-fluid">
              <div class="row text-center">
                <div class="col-12  bg-title pt-4 pb-3 title-font">
                  <h1>CONGRATS!</h1>
                </div>
                <div class="col-12 bg-prize pt-0 pb-3">
                  <img :src="this.prize.imgUrl" alt="" class="w-75 pt-lg-5 pt-3 pb-lg-3">
                </div>
                <div class="col">
                  <span class="title-font condition">*Valid with the purchase of a Vacation Package to Mexico.</span>
                  <lotteryForm :prizeCode="this.prize.code" :prizeName="this.prize.name" />
                  <h3 class="code text-uppercase text-white pt-3 pb-3">to redeem your prize!</h3>
                </div>
              </div>
            </div>
            <!-- <div class="col-12 bg-dark-pink pt-md-4 pb-md-3">
              <h1>congrats!</h1>
            </div>
            <img :src="prizeImageUrl" alt="" class="w-75 pt-md-4 pt-2 pb-md-3 pb-2">
            <h6>*Valid with the purchase of a Vacation Package to Mexico.</h6>
            <lotteryForm :prizeCode="this.prizeLbl" :prizeName="prizeName" />
            <h1 class="code">to redeem your prize!</h1> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lotteryForm from '@/components/TheLotteryForm.vue'
import Confetti from 'canvas-confetti'

export default {
  data() {
    return {
      prize: {
        code: '',
        name: '',
        imgUrl: ''
      },
      defaults: {
        spread: 360,
        ticks: 50,
        gravity: 0,
        decay: 0.94,
        startVelocity: 30,
        colors: ['FFE400', 'FFBD00', 'E89400', 'FFCA6C', 'FDFFB8']
      },
      hasPlayed: localStorage.getItem("prize")
    }
  },
  components: {
    lotteryForm
  },
  methods: {
    showModal(close, open, confetti, hasPlayed) {
      if (confetti) {
        Confetti({
          particleCount: 100,
          spread: 70,
          origin: { y: 0.6 },
          zIndex: 2000,
          shapes: ['circle'],
          colors: ['#FFD700']
        })
      }

      if (this.hasPlayed == 'true') {
        console.log('PLAYED')
      } else {
        var pagebutton = document.getElementById(close);
      pagebutton.click();
      let bannerModal = document.querySelector(open);
      //eslint-disable-next-line
      const bannerModalInstance = new bootstrap.Modal(bannerModal);
      bannerModalInstance.show();
      }
    },
    getRandomInt(max) {
      return Math.floor(Math.random() * max);
    },
    setPrize() {
      switch (this.getRandomInt(4)) {
        case 0:
          this.prize.code = '#VALORLANDO',
            this.prize.name = 'FREE VACATION In ORLANDO',
            this.prize.imgUrl = require('@/assets/images/campaigns/st-patricks/prizes/prize-01.png')
          break;
        case 1:
          this.prize.code = '#VAL1OODIS',
            this.prize.name = '$100 usd DISCOUNT',
            this.prize.imgUrl = require('@/assets/images/campaigns/st-patricks/prizes/prize-02.png')
          break;
        case 2:
          this.prize.code = '#VALVEGAS',
            this.prize.name = 'FREE VACATION IN LAS VEGAS',
            this.prize.imgUrl = require('@/assets/images/campaigns/st-patricks/prizes/prize-03.png')
          break;
        case 3:
          this.prize.code = '#VAL75DIS'
          this.prize.name = '$75 usd DISCOUNT',
            this.prize.imgUrl = require('@/assets/images/campaigns/st-patricks/prizes/prize-04.png')
          break;
        case 4:
          this.prize.code = '#VAL50DlS',
            this.prize.name = '$50 usd DISCOUNT',
            this.prize.imgUrl = require('@/assets/images/campaigns/st-patricks/prizes/prize-05.png')
          break;
        default:
          break;
      }
    },
  },
  mounted() {
    // this.setPrize()
    // this.showModal('closePrizeModal', '#modalBannerWheel')
  }
}
</script>

<style scoped>
.backgr {
  background-color: #39720b;
  background-size: cover;
}

.bg-title {
  background-color: #f4af16;
}

.title-font {
  font-family: Gotham;
  color: #ffef;
}

.special-title-font {
  font-family: Cabinet;
  color: #9cd517;
  font-size: 290%;
}

.bg-pot {
  background-image: url(../assets/images/campaigns/st-patricks/bg-pot.png);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.bg-prize {
  background-color: #39720b;
}

.condition {
  font-size: 12px;
}

@media only screen and (max-width: 600px) {
  .condition {
    font-size: 10px;
  }
}

@keyframes tilt-n-move-shaking {
  0% {
    transform: translate(0, 0) rotate(0deg);
  }

  25% {
    transform: translate(5px, 5px) rotate(5deg);
  }

  50% {
    transform: translate(0, 0) rotate(0eg);
  }

  75% {
    transform: translate(-5px, 5px) rotate(-5deg);
  }

  100% {
    transform: translate(0, 0) rotate(0deg);
  }
}

.pot.tilt-n-move-shaking {
  animation: tilt-n-move-shaking 0.30s infinite;
}

.pot {
  padding-top: 39%;
}
</style>